// Whether the page is going away. Once it is, the browser cancels the page's
// in-flight requests (a keepalive request still reaches the server) and each
// one rejects with "Failed to fetch": the page unloading, not a failure to
// report. A page restored from the back/forward cache is live again.
let hidden = false

if (typeof window !== "undefined") {
  window.addEventListener("pagehide", () => {
    hidden = true
  })
  window.addEventListener("pageshow", () => {
    hidden = false
  })
}

export function isPageUnloading(): boolean {
  return hidden
}
